import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import 'react-tagsinput/react-tagsinput.css';
import { Alert, Button } from 'reactstrap';
import { logout } from '../../actions/user';
import { unregister } from '../../utils/Api';
import { getErrorMessageKey } from '../../utils/helper';

const mapStateToProps = ({ i18n: { translations } }) => ({
  translations,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  logoutAction: logout,
}, dispatch);

const Unregister = ({ intl, translations, allow_registration, allow_unregistration, logoutAction }) => {
  const [errorMessage, setErrorMessage] = useState('');

  const unregisterUser = () => {
    setErrorMessage('');
    if (!confirm(intl.formatMessage({ id: 'profile_delete_user' })))
      return;

    unregister().then(({ error }) => {
      if (error) {
        const errorMessage = getErrorMessageKey(translations, error.code) || error.msg;
        setErrorMessage(intl.formatMessage({ id: errorMessage }) || 'Error unregistering user');
      } else {
        logoutAction();
      }
      return true;
    });
  };

  return (
    <Button
      onClick={unregisterUser}
      color="secondary"
      size="lg"
      disabled={!allow_registration || !allow_unregistration}
    >
      <FormattedMessage id="profile_unregister" />
      {errorMessage && <Alert color="danger"><FormattedMessage id={errorMessage} /></Alert>}
    </Button>
  );
};

Unregister.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any),
  translations: PropTypes.objectOf(PropTypes.object).isRequired,
  allow_registration: PropTypes.bool.isRequired,
  allow_unregistration: PropTypes.bool.isRequired,
  logoutAction: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Unregister));



// WEBPACK FOOTER //
// ./src/views/_Profile/Unregister.js